<template>
  <widget-temp widgetTitle="Đơn mua hộ" widgetName="OrderSummary" v-bind:widgetId="1">
    <template slot="widget-content">
      <div class="performance-block">
        <div class="row">
            <ul class="group-box-mb">
                <li v-for="item in listStatus" :key="item.value" :style="{ 'color': item.color }">
                    <span><a href="javascript:void(0)" @click="gotoOrderList(item.value)">{{item.name}} ({{getTotalOrder(item.value)}})</a></span>
                </li>
            </ul>
             <div class="row group-box">
                <div class="col-md-2">
                    <a href="javascript: void(0)"
                        @click="gotoOrderList(-1)"
                        style="border-left-color: #bdc3d1"
                        class="btn btn-default btn-sm btn-block btn-status">
                        Tất cả<br/>({{getTotalOrder(-1, false)}})
                    </a>
                </div>
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-3 pa-0 pl-2 pr-2" v-for="status of listStatus" v-bind:key="status.value">
                            <a v-if="status.value != -2" href="javascript: void(0)"
                                @click="gotoOrderList(status.value)"
                                :style="{ 'border-left-color': status.color }"
                                class="btn btn-default btn-sm btn-block btn-order-status">
                                {{ status.name }}
                                <span class="total">{{getTotalOrder(status.value)}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>       
        </div>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
export default {
  name: "order-summary",
  data() {
      return { 
          listStatus: configs.ORDER_STATUS,
        }
  },
  computed: {
    ...mapState({
      orderSummary: state => state.dashboard.orderSummary
    })
  },
  methods: {
    getChartData() {
      this.$store.dispatch("dashboard/getOrderSummary");
    },
    getTotalOrder(status, format = true) {
        var total = 0;
        if(!this.orderSummary) {
            return 0;
        }
        switch (status) {
            case 0:
                total = this.orderSummary.TotalStatus0;
                break;
            case 1:
                total = this.orderSummary.TotalStatus1;
                break;
            case 2:
                total = this.orderSummary.TotalStatus2;
                break;
                case 3:
                total = this.orderSummary.TotalStatus3;
                break;
            case 5:
                total = this.orderSummary.TotalStatus5;
                break;
            case 14:
                total = this.orderSummary.TotalStatus14;
                break;
            case 6:
                total = this.orderSummary.TotalStatus6;
                break;
            case 7:
                total = this.orderSummary.TotalStatus7;
                break;
            case 8:
                total = this.orderSummary.TotalStatus8;
                break;
            case 9:
                total = this.orderSummary.TotalStatus9;
                break;
            case 10:
                total = this.orderSummary.TotalStatus10;
                break;
            case 11:
                total = this.orderSummary.TotalStatus11;
                break;
            case 12:
                total = this.orderSummary.TotalStatus12;
                break;
            case 13:
                total = this.orderSummary.TotalStatus13;
                break;
            case 16:
                total = this.orderSummary.TotalStatus16;
                break;
            default:
                total = this.orderSummary.TotalStatusAll;
                break;
        }

        if(total == undefined) {
            total = 0;
        }

        if(total < 999 || !format) {
            return total.toLocaleString('en-US');
        }
        return (Math.floor(total / 1000, 0)).toLocaleString('en-US') + 'K';
    },
    gotoOrderList: function(status) {
      this.$router.push({
        name: "OrderList",
        params: {
          manualTitle: true,
          title: `Danh sách đơn hàng`
        },
        query: { 'status': status }
      });
    },
  },
  mounted: function() {
    this.getChartData();
  }
};
</script>

<style  lang="scss" scoped>
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.42857143;
    border-radius: 2px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.btn-default {
    color: #000000;
    background-color: #ffffff;
    border-color: #bdc3d1;
    text-decoration: none;
}
.btn-status {
    height: 87px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-left: 3px solid;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 2px;
}
.btn-block {
    width: 100%;
}
.btn-default:hover {
    color: #696c74;
    background-color: #ededed;
    border-color: #9fa8bc;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px 4px;
}
.btn-order-status {
    border-left: 3px solid;
    margin-bottom: 3px;
    span {
        float: right;
        text-align: right;
        border-left: 1px solid;
        border-color: #bdc3d1;
        width: 15%;
        height: 100%;
    }
}
.btn-m-status {
    border-left: 3px solid;
}
.group-box-mb {
    display: none;
    .group-status {
        width: 100%;
        background: #fff;
        border: 1px solid #d8dce3;
        box-shadow: none;
        .btn-toggle {
            width: 100%;
            color: #696c74;
        }
        .dropdown-menu {
            width: 100%;
        }
    }
}

.active-status {
    color: #ffffff;
    background-color: #3b4354;
    border-color: #3b4354;
    a:hover {
        color: #ffffff;
        background-color: #3b4354;
        border-color: #3b4354;
    }
    a {
        color: #ffffff;
    }
}
.divider {
    margin: 0px 0px;
}
.filter-text-box {
    margin-top: 15px;
    margin-bottom: 0px;
    .form-control {
        border: 0px;
        border-bottom: 1px solid #bdc3d1;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
}
.muuri-item {
    min-height: 0 !important;
    height: 200px !important;
}
@media (max-width: 992px) {
    .group-box-mb {
        display: block;
    }
    .group-box {
        display: none;
    }
}
@media (max-width: 686px) {
    .widget-block .content-widget .performance-block .title-stt {
        font-size: 14px;
        line-height: 1.2; }
    .widget-block .content-widget .performance-block .num {
        font-size: 28px; } }
    @media (max-width: 500px) {
    .widget-block .content-widget .performance-block .col.col-4, .widget-block .content-widget .performance-block .col.col-8 {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%; }
    .widget-block .content-widget .performance-block .div-table.height-2 {
        height: 150px !important; } }
.widget-block .content-widget .stt-block{margin-bottom:10px;}
.performance-block .col > .col{padding: 0;}
.performance-block .col > .col > .col{padding: 0;}
.performance-block .row{margin: 0px;}
.performance-block .col{padding:0px;}
</style>